<template>
  <div>
    <v-layout>
      <v-flex>
        <v-card class="px-8 py-4">
          <v-layout>
            <v-select
                    v-model="selected_faculty"
                    :items="faculties"
                    label="Fakülte Seçin"
                    append-icon="arrow_downward"
                    single-line
            ></v-select>
          </v-layout>
          <v-layout>
            <v-select
                    v-model="selected_department"
                    :items="departments"
                    label="Bölüm Seçin"
                    append-icon="arrow_downward"
                    single-line
            ></v-select>
          </v-layout>
          <div class="text-right">
            <v-btn class="getDataButton" @click="getData" :disabled="selected_faculty == null || selected_department == null">Verileri Getir</v-btn>
          </div>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import axios from "axios";
export default {
  props: ["tableData", "ranking", "firstUniversity", "firstUniversityText"],
  data() {
    return {
      selected_faculty: null,
      selected_department: null,
      faculties: [
        {
          text: "İletişim Fakültesi",
          value: 0
        },
        {
          text: "İnsan ve Toplum Bilimleri Fakültesi",
          value: 1
        },
        {
          text: "Mühendislik ve Doğa Bilimleri Fakültesi",
          value: 2
        },
        {
          text: "Sağlık Bilimleri Fakültesi",
          value: 3
        },
        {
          text: "Tıp Fakültesi",
          value: 4
        }
      ],
      departments: [],
      allDepartments: [
        [
          "Çizgi Film ve Animasyon",
          "Görsel İletişim Tasarımı",
          "Halkla İlişkiler",
          "Medya ve İletişim",
          "Radyo, Televizyon ve Sinema",
          "Reklam Tasarımı ve İletişimi",
          "Yeni Medya ve Gazetecilik"
        ],
        [
          "Felsefe",
          "Psikoloji",
          "Siyaset Bilimi ve Uluslararası İlişkiler",
          "Sosyoloji",
          "Tarih"
        ],
        [
          "Adli Bilimler",
          "Bilgisayar Mühendisliği",
          "Biyomühendislik",
          {
            text: "Elektronik Mühendisliği",
            value: "Elektronik"
          },
          "Endüstri Mühendisliği",
          "Kimya-Biyoloji Mühendisliği",
          "Moleküler Biyoloji ve Genetik",
          {
            text: "Yazılım Mühendisliği",
            value: "Yazılım"
          }
        ],
        [
          "Beslenme ve Diyetetik",
          "Çocuk Gelişimi",
          "Dil ve Konuşma Terapisi",
          "Ebelik",
          "Ergoterapi",
          "Fizyoterapi ve Rehabilitasyon",
          "Hemşirelik",
          "İş Sağlığı ve Güvenliği",
          "Odyoloji",
          {
            text: "Ortez Protez",
            value: "Ortez-Protez"
          },
          "Perfüzyon",
          "Sağlık Yönetimi",
          "Sosyal Hizmet"
        ],
        [
          {
            text: "Tıp",
            value: "Tıp"
          }
        ]
      ],
      allDepartmentsFromData: [],
      data: [],
      results: []
    };
  },
  async mounted() {
    await axios.get(`/data.json`).then(res => {
      this.data = res.data;
    });
    let allDepartmentsFromData = [];
    let data = this.data;
    for (let i = 0; i < data.length; i++) {
      for (let j = 0; j < data[i].bolumler.length; j++) {
        allDepartmentsFromData.push(data[i].bolumler[j]);
      }
    }
    this.allDepartmentsFromData = allDepartmentsFromData;
    this.$emit("filteredData", []);
  },
  watch: {
    selected_faculty() {
      this.change_faculty();
    },
    selected_department() {
      this.change_department();
    }
  },
  methods: {
    change_faculty() {
      this.departments = this.allDepartments[this.selected_faculty];
      this.$emit("filteredData", []);
    },
    change_department() {
      let departmentData = this.allDepartmentsFromData;
      let results = [];
      for (let i = 0; i < departmentData.length; i++) {
        if (departmentData[i].bolum.indexOf(this.selected_department) >= 0) {
          results.push(departmentData[i]);
        }
      }
      this.rankingFiller(this.ranking(results, "ade"), "ade_ranking");
      this.rankingFiller(this.ranking(results, "bde"), "bde_ranking");
      this.firstUniversity(results, this.firstUniversityText);
      let maxQuote = Math.max.apply(
        Math,
        results.map(function(department) {
          return department.toplam_kontenjan;
        })
      );
      results.forEach(el => {
        el.yge = (el.ytg * (el.toplam_kontenjan / maxQuote)).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&.");
        el.yillik_ucret = el.yillik_ucret.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        el.ytg = el.ytg.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        el.bde = parseFloat(el.bde).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&.");
      });
      this.results = results;
      this.$emit("filteredData", []);
    },
    rankingFiller(arr, key) {
      arr.map((e, i) => {
        e[key] = i + 1;
      });
    },
    getData(){
      this.$emit("filteredData", this.results);
    }
  }
};
</script>

<style scoped>
  .getDataButton {
    background-color: #0ab3ae!important;
    color: #fff!important;
  }
  .getDataButton:hover, .getDataButton:focus {
    background-color: #099d99!important;
  }
</style>
